import { FC, memo } from 'react';
import { Button, ButtonProps } from '@components/UIKit/Button/Button';
import { useUnfollow } from '@hooks/TRPC_Hooks/useUnfollow';
import { useTranslation } from '@hooks/useTranslation';
import { SocialManagerView } from '@specs/views';
interface Props extends Omit<ButtonProps, 'children' | 'id'> {
  shortid: SocialManagerView.publicProfile['shortid'];
}
const MemoizedFollowingButtons: FC<Props> = ({
  shortid,
  ...props
}) => {
  const {
    translate: tr
  } = useTranslation();
  const {
    mutateAsync: unfollowMutate
  } = useUnfollow();
  const unfollowHandler = async () => {
    await unfollowMutate({
      shortid
    });
  };
  return <>
			<Button id='follow_button' {...props} icons={{
      left: {
        name: 'check'
      }
    }} color={'Transparent'} data-sentry-element="Button" data-sentry-source-file="FollowingButton.tsx">
				{tr({
        id: 'btn.following'
      })}
			</Button>
			<Button id='unfollow_button' {...props} color={'White'} onClick={unfollowHandler} data-sentry-element="Button" data-sentry-source-file="FollowingButton.tsx">
				{tr({
        id: 'btn.unfollow'
      })}
			</Button>
		</>;
};
export const FollowingButtons = memo(MemoizedFollowingButtons);